export default __webpack_public_path__ + "static/media/Image-8.d1843aca.png";